import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import Slider from 'react-slick';

import atHome from '@/assets/images/icons/athome.svg';
import svgthird from '@/assets/images/icons/gl-carousel-1-3.svg';
import svgfourth from '@/assets/images/icons/gl-carousel-1-4.svg';
import svgfifth from '@/assets/images/icons/gl-carousel-1-5.svg';
import svgsixth from '@/assets/images/icons/gl-carousel-1-6.svg';
import svgeigth from '@/assets/images/icons/gl-carousel-1-8.svg';
import seamlessHomeImage from '@/assets/images/icons/quickapproval.svg';
import { BannerSettings } from '@/utils/constants/carousel/BannerSettingGl';

export const CarouselGlfh = () => {
  return (
    <section className="bg bg--light investing mfone-first--glfh-carousel">
      <div className="info-slider">
        <Slider {...BannerSettings}>
          <div className="info-slider-item">
            <div className="left">
              <h2 className="text--black text--bold section__title-small">
                Make Your Gold Work
              </h2>
            </div>
            <div className="right">
              <div className="icon-flex mfone-align-items-stretch">
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={seamlessHomeImage}
                    alt="sell anytime"
                  />
                  <p className="text--black text--semi title">
                    <span className="text--bold">Quick Approval</span>
                    <br />
                    Direct Bank Transfer
                  </p>
                </div>
                <div className="item mb-0">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid  mfone-third-svg-carousel"
                    src={svgthird}
                    alt="safety icon"
                  />
                  <p className="text--black text--semi title  mfone-carousel-paragraph">
                    <span className="text--bold"> 11.99%* p.a.</span> (0.99%*
                    p.m.) <br />
                    Low Interest Rates
                  </p>
                </div>
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={atHome}
                    alt="buy as low"
                  />
                  <p className="text--black text--semi title">
                    <span className="text--bold">Seamless</span>
                    <br /> At Home Service
                  </p>
                </div>
              </div>
              <p className="text--medium mt-3">
                *Available only in select cities. T&C applied.
              </p>
            </div>
          </div>
          <div className="info-slider-item">
            <div className="left">
              <h2 className="text--black text--bold section__title-small">
                Make Your Gold Work
              </h2>
            </div>
            <div className="right">
              <div className="icon-flex mfone-align-items-stretch">
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={svgfourth}
                    alt="buy as low"
                  />
                  <p className="text--black text--semi title">
                    Instant Transfer <br /> to Bank <br />
                    Account
                  </p>
                </div>
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={svgfifth}
                    alt="sell anytime"
                  />
                  <p className="text--black text--semi title">
                    100% Access to Your Gold
                  </p>
                </div>
                <div className="item mb-0">
                  {/* style={{ marginLeft: '25px' }} */}
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid mfone-third-svg-carousel"
                    src={svgsixth}
                    alt="safety icon"
                  />
                  <p className="text--black text--semi title mfone-carousel-paragraph">
                    100% Safe & Secure Gold
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="info-slider-item mfone-carousel-info-slider">
            <div className="left">
              <h2 className="text--black text--bold section__title-small">
                Choose How to Make Your Gold Work For You
              </h2>
            </div>
            <div className="right">
              <div className="icon-flex mfone-align-items-stretch">
                <div className="item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={atHome}
                    alt="buy as low"
                  />
                  <p className="text--black text--semi title">
                    <span className="text--bold">Seamless</span>
                    <br /> At Home Service
                  </p>
                </div>
                <div className="item mb-0">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={svgeigth}
                    alt="safety icon"
                  />
                  <p className="text--black text--semi title">
                    Get a Gold Loan from any of our 3800+ branches across India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};
